export default __webpack_public_path__ + "media/zurb/img/party/cupnoodles-34d453a288be5b7a38ad7b03d48095c8.png";